import { render } from "./FeatureView.vue?vue&type=template&id=3774e135"
import script from "./FeatureView.vue?vue&type=script&lang=js"
export * from "./FeatureView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__